import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment,clientId } from '../../env/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class CertificateService {
    public contentType = { 'content-type': 'application/json' };
    private jwtHelper = new JwtHelperService();
    private http: HttpClient;

    constructor(private handler: HttpBackend) {
        this.http = new HttpClient(handler);
    }

    private isValid(token): boolean {
        if (!token) {
            return false;
        }

        try {
             return !this.jwtHelper.isTokenExpired(token);
        } catch (error) {
            return false;
        }
    }

    public getCertificateToken() {
        const token = localStorage.getItem('certificateToken');

        if (!this.isValid(token)) {
            localStorage.removeItem('certificateToken');
            return '';
        }

        return token;
    }

    public renewCertificateToken() {
        return new Observable<Object>(observer => {
            this.getNewCertificateToken().subscribe({
                next(certificate) {
                    localStorage.setItem('certificateToken', certificate['accessToken']);
                    localStorage.setItem('certificateExpiresIn', certificate['expiresIn']);
                    observer.next(certificate);
                    observer.complete();
                },
                error: error => {
                    observer.error(error);
                }
            });
        });
    }

    public authenticate() {
        this.clearCertificate();

        return new Observable<Object>(observer => {
            this.getAccessByClient().subscribe({
                next: client => {
                    this.getIdentificAuthenticationToken(client['accessToken']).subscribe({
                        next: authenticationToken => {
                            localStorage.setItem('clientToken', client['accessToken']);
                            localStorage.setItem('authenticationToken', authenticationToken['token']);
                            observer.next({ url: authenticationToken['url'] });
                            observer.complete();
                        },
                        error: error => {
                            observer.error(error);
                        }
                    });
                },
                error: error => {
                    observer.error(error);
                }
            });
        });
    }

    public clearCertificate() {
        localStorage.removeItem('clientToken');
        localStorage.removeItem('authenticationToken');
        localStorage.removeItem('certificateToken');
        localStorage.removeItem('certificateExpiresIn');
    }

    public validateCertificate(credential: string) {
        return new Observable<boolean>(observer => {
            this.createCertificateToken(credential).subscribe({
                next: certificate => {
                    localStorage.setItem('certificateToken', certificate['accessToken']);
                    localStorage.setItem('certificateExpiresIn', certificate['expiresIn']);
                    observer.next(true);
                    observer.complete();
                },
                error: error => {
                    observer.error(error);
                }
            });
        });
    }

    private getNewCertificateToken() {
        return this.http.post(`${environment.certificateBasePath}/user-identities/change-account`, null, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('certificateToken'),
                ...this.contentType
            }
        });
    }

    private getAccessByClient() {
        console.log("getAccessByClient - certificate")
        return this.http.post(`${environment.certificateBasePath}/client-identities/identify`, null, {
            headers: { ...this.contentType },
            params: { clientId: clientId.certificateAuthentication }
        });
    }

    private getIdentificAuthenticationToken(token) {
        return this.http.post(`${environment.certificateBasePath}/user-identities/leverage-identity-strong`, null, {
            headers: {
                Authorization: 'Bearer ' + token,
                ...this.contentType
            }
        });
    }

    public createCertificateToken(credential: string) {
        const body = { token: localStorage.getItem('authenticationToken'), credential };
        return this.http.post(`${environment.certificateBasePath}/user-identities/auth-identity-strong`, body, {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('clientToken'),
                ...this.contentType
            }
        });
    }
}
